import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const location = useLocation();

  const raw = localStorage.getItem("userDATA");

  // not logged in
  if (!raw) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  let user;
  try {
    user = JSON.parse(raw);
  } catch (e) {
    localStorage.removeItem("userDATA");
    return <Navigate to="/" replace />;
  }

  // logged in but role not allowed
  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;